// extracted by mini-css-extract-plugin
export var spin = "wrapper-module--spin--42df2";
export var wrapper = "wrapper-module--wrapper--e184c";
export var wrapper__container = "wrapper-module--wrapper__container--8326b";
export var wrapper__flexall = "wrapper-module--wrapper__flexall--5e791";
export var wrapper__flexdesktop = "wrapper-module--wrapper__flexdesktop--3f5fc";
export var wrapper__newsletter = "wrapper-module--wrapper__newsletter--5a89e";
export var wrapper__spacer = "wrapper-module--wrapper__spacer--daa90";